import { Input } from 'antd';
import React from 'react';

const CustomInput = (props) => {
  const { size, style, onChange, value, placeholder = '', disabled = false, className } = props;
  return (
    <Input
      style={style}
      className={className}
      size={size}
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};

export default CustomInput;
